import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { deleteAction } from '@/api/manage';
export default {
  name: 'KeysByPrex',
  mixins: [JeecgListMixin],
  components: {},
  data: function data() {
    return {
      pagePath: '/actuator/redis/keysByPrex',
      pageTitle: '令牌管理',
      url: {
        delete: '/actuator/redis/delete',
        deleteBatch: '/actuator/redis/deleteBatch',
        oneClickDelete: '/actuator/redis/oneClickDelete'
      },
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'name',
        colName: 'name',
        title: '用户名',
        align: 'center',
        width: 120
      }, {
        dataIndex: 'token',
        colName: 'token',
        title: 'token信息',
        align: 'center',
        ellipsis: false
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  created: function created() {
    this.queryParam.name = this.$store.getters.userInfo.username;
    this.loadData(1);
  },
  computed: {},
  methods: {
    handleDelete: function handleDelete(keys) {
      var _this = this;

      var that = this;
      deleteAction(that.url.delete, {
        keys: keys
      }).then(function (res) {
        if (res.success) {
          _this.$message_custom(res.message);

          if (that.delRefresh) {
            _this.queryParam = {};
          }

          that.loadData();
        } else {
          _this.$message_custom(res.message, 'warning');
        }
      });
    },
    batchDel: function batchDel() {
      if (this.selectedRowKeys.length <= 0) {
        this.$message_custom('请选择' + this.pageTitle + '记录！', 'warning');
        return;
      } else {
        var ids = '';

        for (var a = 0; a < this.selectionRows.length; a++) {
          ids += this.selectionRows[a].keys + ',';
        }

        var that = this;
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中' + this.pageTitle + '数据?',
          onOk: function onOk() {
            deleteAction(that.url.deleteBatch, {
              keys: ids
            }).then(function (res) {
              if (res.success) {
                that.$message_custom(res.message);
                that.onClearSelected();
                that.loadData();
              } else {
                that.$message_custom(res.message, 'warning');
              }
            });
          }
        });
      }
    },
    oneClickDelete: function oneClickDelete() {
      var that = this;
      debugger;
      var prex = this.getQueryParams().name;
      this.$confirm({
        title: '确认删除',
        content: '是否删除全部' + this.pageTitle + '数据?',
        onOk: function onOk() {
          deleteAction(that.url.oneClickDelete, {
            prex: prex
          }).then(function (res) {
            if (res.success) {
              that.$message_custom(res.message);
              that.loadData();
              that.onClearSelected();
            } else {
              that.$message_custom(res.message, 'warning');
            }
          });
        }
      });
    }
  }
};